import { useQuery } from '@tanstack/react-query';

import {
  type TpFeatureFlags,
  getUserFeatureFlags,
} from '@features/Unsubscribe/api/getUserFeatureFlags';
import { useGetAppName } from 'src/utils/hooks';

export const useGetUserFeatureFlags = ({
  userId,
  email,
}: {
  userId?: string;
  email?: string;
}) => {
  const app = useGetAppName();

  return useQuery<TpFeatureFlags>({
    queryKey: ['user-feature-flags', userId, email, app],
    queryFn: () => getUserFeatureFlags({ userId: userId!, email: email!, app }),
    enabled: !!(userId || email),
    gcTime: 10 * 1000 * 60, // 10 minutes
    staleTime: 10 * 1000 * 60, // Consider data fresh for 10 minutes
  });
};
